import CopyToClipboardButton from 'flow/components/buttons/CopyToClipboardButton';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Icon from 'flow/components/ui-components/Icon';
import InputField from 'flow/components/ui-components/InputField';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectAccessToken } from 'flow/selectors/integration-access-selectors';

const CreateTokenSuccessDialog = () => {
    const { i18next } = useAppContext();

    const createdAccessToken = useAppSelector(selectAccessToken);

    return (
        <BaseModal
            open={true}
            className="w-[600px]"
            header=" "
            confirmButtonText={i18next.t('ok')}
            hideCancelButton={true}
            onSubmit={() => {}}
        >
            <div className="flex flex-1 flex-col items-center overflow-y-scroll px-4 py-20">
                <Icon
                    iconKey={'success'}
                    size="5rem"
                    className="text-green mb-2"
                />

                <h1 className="my-4 text-2xl/6 font-bold text-gray-800">
                    {i18next.t('settings.integrations.token_created_header')}
                </h1>

                <p className="text-sm/6">
                    {i18next.t('settings.integrations.token_created_text')}
                </p>

                <div className="my-9 flex w-[400px] gap-2">
                    <InputField
                        defaultValue={createdAccessToken}
                        readOnly={true}
                        className="bg-gray-200"
                    />
                    <CopyToClipboardButton
                        data={createdAccessToken}
                        className="hover:bg-main hover:darken-0 size-10 hover:text-white"
                        color="gray"
                    />
                </div>

                <p
                    dangerouslySetInnerHTML={{
                        __html: i18next.t(
                            'settings.integrations.token_created_warning',
                        ),
                    }}
                    className="text-sm/6"
                />
            </div>
        </BaseModal>
    );
};

export default CreateTokenSuccessDialog;
